<app-breadcrumb [title]="categoryDet.name" [breadcrumb]="categoryDet.name"></app-breadcrumb>
<!-- section start -->
<section class="section-b-space">
    <div class="collection-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-lg-3">
                    <div class="collection-filter" [class.openFilterbar]="mobileSidebar">
                        <!-- side-bar colleps block stat -->

                        <div class="bg-zk-light mb-3 rounded10 border shadow border-dark fs">
                            <div class="pt-4 pb-3 px-3">
                                <div class="form-label fs-5  fw-bold">My Location:</div>
                                <div class="fs-zk-14 fw-500 border-0 text-dark mb-2" *ngIf="!getSelectedLab">
                                    <em>................. </em>
                                </div>
                                <div class="fs-zk-14 fw-500 border-0 text-dark mb-2" *ngIf="getSelectedLab">
                                    <p>
                                      {{ getSelectedLab?.name }}<br />
                                      {{ getSelectedLab?.address }}, {{ getSelectedLab?.county }},
                                      {{ getSelectedLab?.city }},
                                      {{ getSelectedLab?.state }}
                                      {{ getSelectedLab?.zip_code }}
                                    </p>
                                  </div>
                                  <a class=" text-decoration-underline rounded-0 w-100 mt-3 fs-6 variant " href="/find-lab">Find a Lab</a>
                            </div>
                        </div>

                        <div class="collection-filter-block">
                            <div class="collection-mobile-back" (click)="toggleMobileSidebar()">
                                <span class="filter-back">
                                    <i class="fa fa-angle-left" aria-hidden="true"></i> back
                                </span>
                            </div>
                            <!-- Category filter start -->
                            <app-categories></app-categories>
                        </div>
                        <!-- silde-bar colleps block end here -->
                        <!-- side-bar colleps block stat -->
                        <!-- <div class="collection-filter-block"> -->
                            <!-- brand filter start -->
                            <!-- <app-brands [products]="products" [brands]="brands" (brandsFilter)="updateFilter($event)">
                            </app-brands> -->

                        <!-- </div> -->
                        <!-- silde-bar colleps block end here -->
                        <!-- side-bar single product slider start -->
                        <!-- <app-product-box-vertical-slider [title]="'New Products'">
                        </app-product-box-vertical-slider> -->
                        <!-- side-bar single product slider end -->
                        <!-- side-bar banner start here -->
                        <!-- <div class="collection-sidebar-banner">
                            <a [routerLink]="['/shop/collection/left/sidebar']">
                                <img src="assets/images/collection-sidebar-banner.png" class="img-fluid" alt="banner">
                            </a>
                        </div> -->
                        <!-- side-bar banner end here -->
                    </div>
                </div>
                <div class="collection-content col">
                    <div class="page-main-content">
                        <div class="row">
                            <div class="col-sm-12">
                                <ul class="product-filter-tags">
                                    <li class="me-1" *ngFor="let tag of tags">
                                        <a href="javascript:void(0)" class="filter_tag">
                                            {{tag}} <i class="ti-close" (click)="removeTag(tag)"></i>
                                        </a>
                                    </li>
                                    <li class="clear_filter" *ngIf="tags.length > 0">
                                        <a href="javascript:void(0)" class="clear_filter" (click)="removeAllTags()">
                                            Clear all
                                        </a>
                                    </li>
                                </ul>
                                <div class="collection-product-wrapper" id="products">
                                    <app-grid [products]="categoryDet.product" [paginate]="paginate" [layoutView]="layoutView" [sortBy]="sortBy" (setGrid)="updateGridLayout($event)" (setLayout)="updateLayoutView($event)" (sortedBy)="sortByFilter($event)">
                                    </app-grid>
                                    <div class="product-wrapper-grid" [ngClass]="layoutView">
                                        <div class="row">
                                            <ng-container *ngIf="categoryDet.childes && categoryDet.childes.length > 0">
                                                <div class="col-grid-box mt-2" [ngClass]="grid" *ngFor="let subCategory of categoryDet.childes">
                                                    <div class="product-box_category w-100  sub-category">
                                                        <app-product-box-three [product]="subCategory" [type]="'subcategory'" [categorySlug]="categoryDet.slug" [thumbnail]="false" [cartModal]="true" [loader]="true">
                                                        </app-product-box-three>
                                                    </div>
                                                </div>
                                            </ng-container>

                                            <ng-container *ngIf="categoryDet && categoryDet.length > 0">
                                                <div class="col-grid-box" [ngClass]="grid" *ngFor="let subcategoryProduct of categoryDet">
                                                  <div class="product-box w-100 mb-4">
                                                    <app-product-box-one [product]="subcategoryProduct" [type]="'product'" [currency]="_productService?.Currency" [thumbnail]="false" [cartModal]="true" [loader]="true">
                                                    </app-product-box-one>
                                                  </div>
                                                </div>
                                              </ng-container>

                                            <ng-container *ngIf="!categoryDet.childes || categoryDet.childes.length === 0">
                                                <div class="col-grid-box mb-4" [ngClass]="grid" *ngFor="let product of categoryDet.product">
                                                    <div class="product-box w-100">
                                                        <app-product-box-one [product]="product" [type]="'product'" [currency]="_productService?.Currency" [thumbnail]="false" [cartModal]="true" [loader]="true">
                                                        </app-product-box-one>
                                                    </div>
                                                </div>
                                            </ng-container>
                                            <div class="col-sm-12 text-center section-b-space mt-5 no-found" *ngIf="!categoryDet.product.length">
                                                <img src="assets/images/empty-search.jpg" class="img-fluid mb-4">
                                                <h3>Sorry! Couldn't find the product you were looking For!!! </h3>
                                                <p>Please check if you have misspelt something or try searching with other words.</p>
                                                <a [routerLink]="['/shop/collection/left/sidebar']" class="btn btn-solid">continue shopping</a>
                                            </div>
                                        </div>
                                    </div>
                                    <app-pagination [products]="products" [paginate]="paginate" (setPage)="setPage($event)">
                                    </app-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- section End -->
